module.exports = __webpack_public_path__ + "img/Hmera_perivallontos_310X588.118b4d18.jpg";